<template>
    <div class="step-section">
        <div class="container">
            <header class="step-section__header" v-if="page.title">
                <h1 class="heading no-arrow heading-static">
                    <b>{{ page.title }}</b>
                </h1>
            </header>
            <div class="step-section__content">
                <div class="row">
                    <div class="col-12">
                        <div class="content-page text-page contact-page">
                            <figure>
                                <img
                                        v-if="companyInfo.logo"
                                        alt="Logo Internorm"
                                        :src="companyInfo.logo"
                                >
                            </figure>

                            <a :href="`tel:${companyInfo.phone }`">
                                <template v-if="companyInfo.phone">
                                    {{ companyInfo.phone }}
                                </template>
                            </a><br>
                            <a :href="`mail:${companyInfo.email }`">{{ companyInfo.email }}</a>
                            <br><br>
                            <address class="address">
                                <span>{{ companyInfo.name }}</span>
                                <span>{{ companyInfo.address }}</span>
                                <span>{{ companyInfo.zip }} {{ companyInfo.city }}</span>
                            </address>

                            <span v-if="companyInfo.hours"><pre
                                    style="white-space: pre-wrap;word-wrap: break-word;font-family: inherit;">{{ companyInfo.hours }}</pre></span>
                            <span v-if="companyInfo.nip">NIP: {{ companyInfo.nip }}</span>

                            <ul>
                                <li v-if="companyInfo.social.facebook"><a
                                        :href="companyInfo.social.facebook"
                                >Facebook</a>
                                </li>
                                <li v-if="companyInfo.social.twitter"><a
                                        :href="companyInfo.social.twitter"
                                >Twitter</a>
                                </li>
                                <li v-if="companyInfo.social.googleplus"><a
                                        :href="companyInfo.social.googleplus"
                                >Google+</a>
                                </li>
                                <li v-if="companyInfo.social.youtube"><a
                                        :href="companyInfo.social.youtube"
                                >YouTube</a>
                                </li>

                                <li v-if="companyInfo.social.instagram"><a
                                        :href="companyInfo.social.instagram"
                                >Instagram</a>
                                </li>
                                <li v-if="companyInfo.social.pinterest"><a
                                        :href="companyInfo.social.pinterest"
                                >Pinterest</a>
                                </li>
                                <li v-if="companyInfo.social.snapchat"><a
                                        :href="companyInfo.social.snapchat"
                                >Snapchat</a>
                                </li>
                                <li v-if="companyInfo.social.flickr"><a
                                        :href="companyInfo.social.flickr"
                                >Flickr</a>
                                </li>
                                <li v-if="companyInfo.social.linkedin"><a
                                        :href="companyInfo.social.linkedin"
                                >Linkedin</a>
                                </li>
                            </ul>

                            <p v-if="companyInfo.url"><a
                                    v-if="companyInfo.url"
                                    :href="companyInfo.url"
                            >{{ $t('goToHomePage') }}</a></p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
  import { mapState, mapActions } from 'vuex'
  import store from '@/store/index'

  export default {
    name: 'Contact',
    data () {
      const { $t } = this
      return {
        page: {
          title: $t('contact')
        },
      }
    },
    metaInfo () {
      const { companyInfo, $t } = this
      return {
        title: $t('contact') + ' | ' + companyInfo.seo_title + ' | ' + $t('titleWindowConfigurator'),
      }
    },
    computed: {
      ...mapState({
        companyInfo: state => state.companyInfo,
      }),
    },
  }
</script>
